
import React from "react";
import { Card } from "@/components/ui/card";
import { Check, X } from "lucide-react";

const plans = [
  {
    name: "Mensal",
    price: "R$ 27,90/mês",
    features: [
      { name: "Acesso total aos módulos principais", included: true },
      { name: "Comunidade (WhatsApp + Discord)", included: true },
      { name: "Planilhas de Treino e Nutrição", included: true },
      { name: "Módulos de Corrida, Musculação e Nutrição", included: true },
      { name: "Novos Módulos Futuros", included: false },
      { name: "Economize?", included: false },
      { name: "Templates Bonus de Produtividade", included: false },
      { name: "Cargo Exclusivo na Comunidade", included: false },
      { name: "Desconto em Produtos (Camisetas, Acessórios)", included: false },
    ],
    cta: "ESCAPAR AGORA",
    link: "https://pay.hotmart.com/H99443264S?off=radwy4cu"
  },
  {
    name: "Anual",
    installmentPrice: "12x de R$ 20,47",
    price: "ou R$ 197 à vista",
    features: [
      { name: "Acesso total aos módulos principais", included: true },
      { name: "Comunidade (WhatsApp + Discord)", included: true },
      { name: "Planilhas de Treino e Nutrição", included: true },
      { name: "Módulos de Corrida, Musculação e Nutrição", included: true },
      { name: "Novos Módulos Futuros", included: true },
      { name: "Economize?", included: true, text: "40% OFF" },
      { name: "Templates Bonus de Produtividade", included: true },
      { name: "Cargo Exclusivo na Comunidade", included: true },
      { name: "Desconto em Produtos (Camisetas, Acessórios)", included: true },
    ],
    cta: "GARANTIR MEU ANO",
    link: "https://pay.hotmart.com/H99443264S?off=nwb6udhe"
  }
];

const PricesSection: React.FC = () => {
  return (
    <section className="section-container" id="planos">
      <h2 className="text-3xl md:text-5xl font-bold mb-8 text-center">
        ESCOLHA SEU CAMINHO PARA ESCAPAR DO ÓBVIO
      </h2>
      <p className="text-xl mb-16 text-center">
        Duas formas de entrar. Uma decisão que muda tudo.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8 max-w-4xl mx-auto">
        {plans.map((plan, index) => (
          <Card key={index} className="p-6 bg-black border-white/20 shadow-lg shadow-white/5 scroll-reveal">
            <h3 className="text-2xl font-bold mb-2 text-white">{plan.name}</h3>
            
            {plan.installmentPrice ? (
              <>
                <div className="text-3xl font-bold mb-1 text-green-400">{plan.installmentPrice}</div>
                <div className="text-lg mb-4 text-white/80">{plan.price}</div>
              </>
            ) : (
              <div className="text-3xl font-bold mb-4 text-white">{plan.price}</div>
            )}
            
            <div className="space-y-4 my-8">
              {plan.features.map((feature, featureIndex) => (
                <div key={featureIndex} className="flex items-center gap-2">
                  {feature.included ? (
                    <Check className="w-5 h-5 text-green-500" />
                  ) : (
                    <X className="w-5 h-5 text-red-500" />
                  )}
                  <span className="text-white">
                    {feature.name}
                    {feature.text && ` (${feature.text})`}
                  </span>
                </div>
              ))}
            </div>
            <a 
              href={plan.link} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="bg-white text-black font-bold rounded-full transition-all hover:bg-opacity-90 focus:outline-none px-6 py-3 text-base inline-block w-full text-center"
            >
              {plan.cta}
            </a>
          </Card>
        ))}
      </div>
      <p className="text-center text-lg opacity-80 animate-pulse">
        Oferta especial por tempo LIMITADO.
        <br />
        Garanta agora enquanto ainda está aberta.
      </p>
    </section>
  );
};

export default PricesSection;
